import { createWidget } from "@opendash/core";



export default createWidget({
  type: "opendash-widget-bcm-cap-map",
  meta: {},
  displayComponent: () => import("./component"),
  settingsComponent: () => import("../locations-common/settings"),
  presets: [
    {
      label: "bcm:widgets.cap-map.name",
      description: "bcm:widgets.cap-map.description",
      imageLink: require("./screenshot.png"),
      layout: [8, 8],
      widget: {
        config: {},
      },
    },
  ],
});
